import { Empty, Spin } from 'antd'
import Pagination from 'components/Pagination'
import {
  EmptyWrapper,
  FlexWrap,
  RowNumberData1,
  RowNumberDriveAlignCenter,
} from 'components/TableStyles/TableContentStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStylesRoles'
import { SubWrapper } from 'modules/Dashboard/Partials/style'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import NoInterview from 'components/Images/NoInterview.png'
import ActionDropdown from './ActionDropdown'
import RolesFilter from './RolesFilter'

const InstitutesDetails = ({
  rolesList,
  loading,
  page,
  setPage,
  setSortBy,
  setSearch,
  search,
  roleFilter,
  setRoleFilter,
  setRoundFilter,
  roundFilter,
  filterData,
  setFilterData,
}) => {
  const navigate = useNavigate()
  const params = useParams()
  const columns = [
    {
      title: 'Role',
      dataIndex: 'roleName',
      sorter: true,
      render: (_, data) => (
        <FlexWrap alignCenter gap="8px">
          <RowNumberData1 onClick={() => selectedRow(data)}>
            {data?.roleName}
          </RowNumberData1>
        </FlexWrap>
      ),
    },
    {
      title: (
        <span>
          Round <br></br>Evaluation Process
        </span>
      ),
      dataIndex: 'interviewRound',
      sorter: true,
      render: (_, data) => (
        <span>
          {' '}
          {`Round ${data?.roundOrder}`} <br></br> {data?.interviewRound}
        </span>
      ),
    },

    {
      title: 'Total Cand',
      dataIndex: 'totalStudents',
      sorter: true,
      render: (_, data) => (
        <RowNumberDriveAlignCenter>
          {' '}
          {data?.totalStudents}{' '}
        </RowNumberDriveAlignCenter>
      ),
    },

    {
      title: 'Interviewed',
      dataIndex: 'interviewedCount',
      sorter: true,
      render: (_, data) => (
        <RowNumberDriveAlignCenter>
          {' '}
          {data?.interviewedCount}{' '}
        </RowNumberDriveAlignCenter>
      ),
    },

    {
      title: 'In Queue',
      dataIndex: 'inQueueCount',
      sorter: true,
      render: (_, data) => (
        <RowNumberDriveAlignCenter>
          {' '}
          {data?.inQueueCount}{' '}
        </RowNumberDriveAlignCenter>
      ),
    },

    {
      title: 'Schedule',
      dataIndex: 'date',
      sorter: true,
      width: '300px',
      render: (text, item) => <ActionDropdown text={'view'} data={item} />,
    },
  ]

  const selectedRow = data => {
    if (params?.userId) {
      navigate(
        `/interviewerRoles/${data?.roleId}/${params?.userId}/${data?.interviewId}/${data?.panelDetailsByDate?.[0]?.date}`
      )
    } else {
      navigate(
        `/interviewerRoles/${data?.roleId}/${data?.interviewId}/${data?.panelDetailsByDate?.[0]?.date}`
      )
    }
  }
  const onPageChange = value => {
    setPage(value - 1)
  }
  const onSorting = (pagination, filter, sorter) => {
    setSortBy(sorter)
  }

  return (
    <SubWrapper>
      <RolesFilter
        jobsList={rolesList}
        searchValue={search}
        setSearchValue={setSearch}
        setPageNum={setPage}
        roleFilter={roleFilter}
        setRoleFilter={setRoleFilter}
        filterData={filterData}
        setFilterData={setFilterData}
        setRoundFilter={setRoundFilter}
        roundFilter={roundFilter}
      />
      <br></br>
      <StyledTable
        columns={columns}
        pagination={false}
        dataSource={rolesList?.panelDetails}
        headerColor={true}
        onChange={onSorting}
        locale={{
          emptyText: (
            <EmptyWrapper center>
              {loading ? (
                <Spin />
              ) : (
                <Empty
                  image={NoInterview}
                  imageStyle={{ height: 360 }}
                  description={
                    <span>
                      Relax!<br></br>
                      No interviews was scheduled!
                    </span>
                  }
                />
              )}
            </EmptyWrapper>
          ),
        }}
      />

      <Pagination
        onChange={onPageChange}
        totalPages={rolesList?.totalPages * 10}
        pageSize={10}
        current={page + 1}
      />
    </SubWrapper>
  )
}

export default InstitutesDetails
